input RequesterInput {
  name: String!
  email: String!
}

input CommentInput {
  body: String
  type: String
}

input ZendeskReportProblemInput {
  requester: RequesterInput!
  subject: String
  comment: CommentInput
  screenshot: String
  org_id: String
  url: String
}
